/*eslint-disable*/
import React, { useRef, useState } from "react";
import { NavLink as NavLinkRRD, Link } from "react-router-dom";
import { FaUserCircle } from "react-icons/fa";
// nodejs library to set properties for components
import { PropTypes } from "prop-types";
import Logo from "../../assets/img/custom/logo.png";
// reactstrap components
import {
  Button,
  Collapse,
  Navbar,
  NavItem,
  NavLink,
  Nav,
  Container,
  Row,
  Col,
  Modal,
  ModalBody,
} from "reactstrap";
import { logout } from "../../store/actions/authActions";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { getNotification } from "store/actions/notificationAction";

const Sidebar = (props) => {
  const [collapseOpen, setCollapseOpen] = useState();
  const [logoutModal, setLogoutModal] = useState(false);
  const [profileDropdownOpen, setProfileDropdownOpen] = useState(false);
  let auth = useSelector((state) => state.auth);
  let dispatch = useDispatch();
  const dropdownRef = useRef(null);
  const profileDropdownRef = useRef(null);
  const logoutToggle = () => {
    setLogoutModal(!logoutModal);
  };
  // verifies if routeName is the one active (in browser input)
  const activeRoute = (routeName) => {
    return props.location.pathname.indexOf(routeName) > -1 ? "active" : "";
  };
  // toggles collapse between opened and closed (true/false)
  const toggleCollapse = () => {
    setCollapseOpen((data) => !data);
  };
  // closes the collapse
  const closeCollapse = () => {
    setCollapseOpen(false);
  };
  // creates the links that appear in the left menu / Sidebar
  const [show, setShow] = useState(false);
  let { unreadNotification } = useSelector((state) => state.notification);

  const toggle = () => {
    setShow(!show);
  };
  useEffect(() => {
    dispatch(getNotification(auth.uid));
  }, []);
  const sendEmail = (obj) => {
    let payload = {
      fanEmail: obj.fanEmail,
      id: obj.id,
    };
    dispatch(sendEmailToFanNotification(payload));
    setShow(false);
  };
  const createLinks = (routes) => {
    return routes.map((prop, key) => {
      if (prop.layout == "/admin" && prop.isMenu != false) {
        return (
          <NavItem key={key}>
            <NavLink
              to={prop.layout + prop.path}
              tag={NavLinkRRD}
              onClick={closeCollapse}
              className={`nav-link ${activeRoute(prop.path) ? "active" : ""}`}
              activeClassName="active"
            >
              {/* <i className={prop.icon} /> */}
              <span className="boldClass">{prop.name}</span>
            </NavLink>
          </NavItem>
        );
      }
    });
  };

  const { bgColor, routes, logo } = props;
  let navbarBrandProps;
  if (logo && logo.innerLink) {
    navbarBrandProps = {
      to: logo.innerLink,
      tag: Link,
    };
  } else if (logo && logo.outterLink) {
    navbarBrandProps = {
      href: logo.outterLink,
      target: "_blank",
    };
  }

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShow(false);
      }
    };

    if (show) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [show]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        profileDropdownRef.current &&
        !profileDropdownRef.current.contains(event.target)
      ) {
        setProfileDropdownOpen(false);
      }
    };

    if (profileDropdownOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [profileDropdownOpen]);

  return (
    <>
      {auth.user.chatRate ? null : (
        <div>
          <marquee
            className="marqueeTagset d-md-none d-block"
            direction="right"
            height="100px"
          >
            You need to set chat rate per minute on your profile section
          </marquee>
        </div>
      )}

      <Navbar
        style={auth.user.chatRate ? { top: "0" } : { top: "23px" }}
        className="navbar-vertical fixed-left navbar-light bg-primary custom-sidebar"
        expand="lg"
        id="sidenav-main"
      >
        <Container fluid>
          {/* ── Mobile top bar: hamburger + bell + profile ── */}
          <div className="d-flex d-lg-none align-items-center w-100">
            {/* Hamburger */}
            <button
              className="navbar-toggler navbar-dark p-0 mr-auto"
              type="button"
              style={{ color: "white", border: "none", background: "none" }}
              onClick={toggleCollapse}
            >
              <span className="navbar-toggler-icon" />
            </button>

            {/* Bell */}
            <div className="position-relative mr-3">
              {unreadNotification?.length > 0 ? (
                <Button
                  className="bg-transparent border-0 nav-notification p-0"
                  onClick={toggle}
                >
                  <i className="fa fa-solid fa-bell notification text-white" style={{ fontSize: 20 }}></i>
                </Button>
              ) : (
                <Button className="bg-transparent border-0 nav-notification p-0" onClick={toggle}>
                  <i className="fa fa-solid fa-bell text-white" style={{ fontSize: 20 }}></i>
                </Button>
              )}
              
              {!show ? null : (
                <div className="dropDown" ref={dropdownRef} style={{ top: '40px', right: '0px' }}>
                  {unreadNotification?.length > 0 ? (
                    unreadNotification.map((items, index) => {
                      return (
                        <React.Fragment key={index}>
                          <h3 className="text-center my-2">
                            A Sports Fan named {items.fanName} just bought an{" "}
                            {items.type && " Endorsement"} badge from you.Would
                            you like to send this Fan an email telling Fan you
                            are ready to chat with him or her? Button below
                            sends that email.You can also check the Question
                            Database on your Chat Home Page to see if this Fan
                            has already posted a question you wish to answer.If
                            yes, you can click one of the 'arrange chat' buttons
                            on Chat Home page to set up Chat.
                          </h3>
                          <hr />
                          <div className="text-right">
                            <Button
                              color="primary my-3 notification_button"
                              onClick={() => sendEmail(items)}
                            >
                              Send Email to Fan who Bought my badge
                            </Button>
                          </div>
                          <hr />
                        </React.Fragment>
                      );
                    })
                  ) : (
                    <p className="text-center">no new notification</p>
                  )}
                </div>
              )}
            </div>

            {/* Profile icon */}
            <div className="position-relative" ref={profileDropdownRef}>
              <div
                style={{ cursor: "pointer" }}
                onClick={() => setProfileDropdownOpen((v) => !v)}
              >
                {auth.user?.player_image?.url || auth.user?.photo || auth.user?.photoURL ? (
                  <img
                    src={auth.user?.player_image?.url || auth.user?.photo || auth.user?.photoURL}
                    alt="profile"
                    style={{
                      width: "34px",
                      height: "34px",
                      borderRadius: "50%",
                      objectFit: "cover",
                      border: "2px solid rgba(255,255,255,0.7)",
                    }}
                  />
                ) : (
                  <FaUserCircle size={32} color="white" />
                )}
              </div>

              {/* Dropdown */}
              {profileDropdownOpen && (
                <div
                  style={{
                    position: "absolute",
                    right: 0,
                    top: "42px",
                    background: "#fff",
                    border: "1px solid #ddd",
                    borderRadius: "8px",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.18)",
                    minWidth: "160px",
                    zIndex: 9999,
                  }}
                >
                  <a
                    href="mailto:jimbeecham@hotmail.com"
                    style={{ ...dropdownItemStyle, textDecoration: "none" }}
                    onClick={() => setProfileDropdownOpen(false)}
                  >
                    Report a Problem
                  </a>
                  <hr style={{ margin: 0 }} />
                  <button
                    style={{ ...dropdownItemStyle, color: "#e53935" }}
                    onClick={() => {
                      setProfileDropdownOpen(false);
                      logoutToggle();
                    }}
                  >
                    Logout
                  </button>
                </div>
              )}
            </div>
          </div>
          {/* Collapse */}
          <Collapse navbar isOpen={collapseOpen}>
            {/* Collapse header */}
            <div className="navbar-collapse-header d-lg-none">
              <Row>
                {logo ? (
                  <Col className="collapse-brand" xs="6">
                    {logo.innerLink ? (
                      <Link to="/">
                        <img alt={logo.imgAlt} src={Logo} />
                      </Link>
                    ) : (
                      <a href="/">
                        <img alt={logo.imgAlt} src={Logo} />
                      </a>
                    )}
                  </Col>
                ) : null}
                <Col className="collapse-close" xs="6">
                  <button
                    className="navbar-toggler"
                    type="button"
                    onClick={toggleCollapse}
                  >
                    <span />
                    <span />
                  </button>
                </Col>
              </Row>
            </div>
            <Modal isOpen={logoutModal} centered toggle={logoutToggle}>
              <ModalBody>
                <div className="text-center">
                  <i
                    className="fa fa-sign-out-alt text-primary"
                    style={{ fontSize: 70 }}
                  ></i>
                  <br />
                  <br />
                  <span className="mt-5" style={{ fontSize: 30 }}>
                    Are you sure?
                  </span>
                  <br />
                  <br />
                  <span className="mt-5" style={{ fontSize: 16 }}>
                    You want to logout.
                  </span>
                  <br />
                  <br />
                  <br />
                  <Button color="danger" onClick={logoutToggle}>
                    Cancel
                  </Button>{" "}
                  <Button color="primary" onClick={() => dispatch(logout())}>
                    Logout
                  </Button>
                </div>
              </ModalBody>
            </Modal>
            {/* Navigation */}
            <Nav navbar>{createLinks(routes)}</Nav>
            <Nav className="mb-md-3" navbar>
              <NavItem className="nav-bottom">
                <Link
                  to={{
                    pathname: `/terms-and-conditions`,
                    search: "?" + `admin`,
                  }}
                  className="nav-link"
                  style={{
                    textDecoration: "none",
                    color: "inherit",
                    fontWeight: "bold",
                  }}
                >
                  Terms &amp; Conditions
                </Link>
              </NavItem>
            </Nav>
          </Collapse>
        </Container>
      </Navbar>
    </>
  );
};

Sidebar.defaultProps = {
  routes: [{}],
};

Sidebar.propTypes = {
  // links that will be displayed inside the component
  routes: PropTypes.arrayOf(PropTypes.object),
  logo: PropTypes.shape({
    // innerLink is for links that will direct the user within the app
    // it will be rendered as <Link to="...">...</Link> tag
    innerLink: PropTypes.string,
    // outterLink is for links that will direct the user outside the app
    // it will be rendered as simple <a href="...">...</a> tag
    outterLink: PropTypes.string,
    // the image src of the logo
    imgSrc: PropTypes.string.isRequired,
    // the alt for the img
    imgAlt: PropTypes.string.isRequired,
  }),
};

const dropdownItemStyle = {
  display: "block",
  width: "100%",
  padding: "10px 16px",
  background: "none",
  border: "none",
  textAlign: "left",
  fontSize: "14px",
  cursor: "pointer",
  color: "#333",
};

export default Sidebar;
